"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Row = exports.ResponsiveRow = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _jsxRuntime = require("react/jsx-runtime");

var _react = require("@fluentui/react");

var React = _interopRequireWildcard(require("react"));

var _ResponsiveCell = require("./ResponsiveCell");

var _ResponsiveGridMarkers = require("./ResponsiveGridMarkers");

/**
 * Row section of a `<ResponsiveGrid>`. Should either be the immediate child of
 * the grid, or of a `<ResponsiveColumn>`.
 *
 * Rows pivot to render their children _vertically_ when the window width
 * shrinks to the responsive pivot size given at the grid level
 * (`<ResponsiveGrid responsivePivot={...}>`).
 */
var ResponsiveRow = function ResponsiveRow(_ref) {
  var className = _ref.className,
      children = _ref.children,
      props = (0, _objectWithoutProperties2.default)(_ref, ["className", "children"]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponsiveCell.ResponsiveCell, (0, _objectSpread2.default)((0, _objectSpread2.default)({
    className: (0, _react.css)('ms-ResponsiveGrid--row', className),
    direction: 'row'
  }, props), {}, {
    children: children
  }));
};

exports.Row = exports.ResponsiveRow = ResponsiveRow;

_ResponsiveGridMarkers.ResponsiveGridCellMarker.mark(ResponsiveRow);